import {useMemo} from 'react'
import {getDisBaseUrl} from '../utils/dis-utils'
import useOcapiSite from './useOcapiSite'

/**
 * Custom hook to convert an image URL to DIS (Dynamic Image Service) base URL.
 * Uses the sharedLibraryDis URL from OCAPI to generate the DIS URL.
 * This hook memoizes the result to avoid unnecessary recalculations.
 *
 * @param {string} imageUrl - The image URL to convert
 * @returns {string|null} The DIS base URL or null if the URL is invalid or sharedLibraryDis is not loaded
 *
 * @example
 * function MyComponent() {
 *   const imageUrl = 'https://dev.stokke.com/on/demandware.static/-/Library-Sites-StokkeSharedLibrary/default/dwc6da04cc/cms_assets/image.png'
 *   const disUrl = useDisBaseLink(imageUrl)
 *   // disUrl: 'https://dev.stokke.com/dw/image/v2/aaqf_dev/on/demandware.static/-/Library-Sites-StokkeSharedLibrary/default/dwc6da04cc/cms_assets/image.png'
 * }
 */
export default function useDisBaseLink(imageUrl) {
    const {sharedLibraryDis} = useOcapiSite()

    return useMemo(() => getDisBaseUrl(imageUrl, sharedLibraryDis), [imageUrl, sharedLibraryDis])
}
